/**
 * Domů :: Zobrazit úvodní stránku
 */
export const LOC_KEY_MENU_PANEL_HOME = "GUI-301352";
export const LOC_KEY_MENU_PANEL_QUICK_ACCESS = "GUI-702937"; // Rychlý přístup :: Rychlý přístup
export const LOC_KEY_MENU_PANEL_USER = "GUI-171048"; // Uživatel :: Uživatel aplikace - menu

export const LOC_KEY_QUICK_ACCESS_MENU_OPENED_ITEMS = "GUI-618614"; // Otevřené formuláře :: Otevřené formuláře
export const LOC_KEY_QUICK_ACCESS_MENU_HISTORY_ITEMS = "GUI-703195"; // Historie formulářů :: Historie formulářů
export const LOC_KEY_QUICK_ACCESS_MENU_FAVORITES = "GUI-103"; // Oblíbené :: Oblíbené

export const LOC_KEY_EXPAND_MENU = "GUI-618613"; // Rozbalit menu :: Rozbalit menu
export const LOC_KEY_COLLAPSE_MENU = "GUI-618612"; // Sbalit menu :: Sbalit menu

export const LOC_KEY_USER_MENU_LOGOUT = "GUI-151646"; // Odhlásit :: Odhlásit
export const LOC_KEY_USER_MENU_SETTINGS = "GUI-101"; // Nastavení :: Nastavení
export const LOC_KEY_THEME_DARK = "GUI-652509"; // Tmavé téma :: Tmavé téma
export const LOC_KEY_THEME_LIGHT = "GUI-652510"; // Světlé téma :: Světlé téma

export const LOC_KEY_ACTION_ITEM_OPEN_FORM = "GUI-618615"; // Otevřít v nové záložce menu :: Otevře formulář do nové záložky menu
export const LOC_KEY_ACTION_ITEM_OPEN_FORM_IN_TAB = "GUI-653847"; // Otevřít v nové záložce prohlížeče :: Otevře formulář v nové záložce prohlížeče
export const LOC_KEY_ACTION_ITEM_FAVORITES_ADD = "GUI-1006"; // Přidat do oblíbených :: Přidat do oblíbených
export const LOC_KEY_ACTION_ITEM_FAVORITES_REMOVE = "GUI-508345"; // Odebrat z oblíbených :: Odebrat z oblíbených
export const LOC_KEY_ACTION_ITEM_CLOSE = "GUI-4447"; // Zavřít :: Zavřít

export const LOC_KEY_SEARCH_FIELD_PLACEHOLDER = "GUI-651767"; // Hledat :: Fulltextové hledání ve vybraných atributech

export const LOC_KEY_NO_NOTIFICATION_ITEMS = "GUI-489002"; // Žádné záznamy. V tomto seznamu nemáme co zobrazit. :: Žádné záznamy. V tomto seznamu nemáme co zobrazit.
export const LOC_KEY_SHOW_GROUP_NOTIFICATIONS = "GUI-602236"; // Zobrazit vše :: Zobrazit všechny přijaté oznámení
export const LOC_KEY_SET_ALL_NOTIFICATION_AS_READ = "GUI-792167"; // Označit vše jako přečtené :: Označit všechny notifikace jako přečtené
export const LOC_KEY_LOADING = "GUI-580532"; // Načítám :: Načítám

/**
 * Obsahuje staticky definované lokalizační klíče pro menu.
 */
export const STATIC_LOC_KEYS = [
    LOC_KEY_MENU_PANEL_HOME,
    LOC_KEY_MENU_PANEL_QUICK_ACCESS,
    LOC_KEY_QUICK_ACCESS_MENU_OPENED_ITEMS,
    LOC_KEY_QUICK_ACCESS_MENU_HISTORY_ITEMS,
    LOC_KEY_QUICK_ACCESS_MENU_FAVORITES,
    LOC_KEY_MENU_PANEL_USER,
    LOC_KEY_EXPAND_MENU,
    LOC_KEY_COLLAPSE_MENU,
    LOC_KEY_USER_MENU_LOGOUT,
    LOC_KEY_USER_MENU_SETTINGS,
    LOC_KEY_THEME_DARK,
    LOC_KEY_THEME_LIGHT,
    LOC_KEY_ACTION_ITEM_OPEN_FORM,
    LOC_KEY_ACTION_ITEM_OPEN_FORM_IN_TAB,
    LOC_KEY_ACTION_ITEM_FAVORITES_ADD,
    LOC_KEY_ACTION_ITEM_FAVORITES_REMOVE,
    LOC_KEY_SEARCH_FIELD_PLACEHOLDER,
    LOC_KEY_ACTION_ITEM_CLOSE,
    LOC_KEY_NO_NOTIFICATION_ITEMS,
    LOC_KEY_SHOW_GROUP_NOTIFICATIONS,
    LOC_KEY_SET_ALL_NOTIFICATION_AS_READ,
    LOC_KEY_LOADING,
];
